var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { show: _vm.show, width: "605px" },
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        ),
        _vm._v(" "),
        _vm.title
          ? _c("h1", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer text" }, [
        _vm.textA
          ? _c("p", { staticClass: "text" }, [_vm._v(_vm._s(_vm.textA))])
          : _vm._e(),
        _vm._v(" "),
        _vm.textB
          ? _c("p", { staticClass: "text" }, [_vm._v(_vm._s(_vm.textB))])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70f04c74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f04c74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalTooltip.vue
// module id = null
// module chunks = 